import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AngularMaterialModule } from 'src/app/shared/module/angular-material.module';
import { IssueDto } from '../models/issue';
import { ReportIssueFormComponent, ReportIssueResult } from '../report-issue-form/report-issue-form.component';

export interface ReportIssueDialogData {
  assetId: string;
  assetName: string;
  assetVin: string;
  openIssues: IssueDto[];
}

export type ReportIssueDialogResult = ReportIssueResult;

@Component({
  selector: 'app-report-issue-dialog',
  templateUrl: './report-issue-dialog.component.html',
  styleUrl: './report-issue-dialog.component.scss',
  standalone: true,
  imports: [AngularMaterialModule, TranslateModule, ReportIssueFormComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportIssueDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReportIssueDialogData,
    private readonly dialogRef: MatDialogRef<ReportIssueDialogComponent>,
  ) {}

  close(result?: ReportIssueResult): void { this.dialogRef.close(result); }
}
